import $ from 'jquery';

class CartHandler {
    date = null;
    time = null;
    adult = 0;
    youth = 0;
    child = 0;
    productType = '';

    constructor() {
        document.addEventListener('DOMContentLoaded', () => {
            if (document.getElementById("booking-on-pdp")) {
                this.productType = $("input[name='post_type']").val();
                this.repopulateBookingForm();
                this.loadCalendar();
                this.bindEvents();
                this.updateBookingSummary();
            }
        });
    }

    // ------------------- INIT -------------------
    bindEvents() {
        $(".pts-amount-plus").on("click", (e) => this.handleParticipantChange(e, 1));
        $(".pts-amount-minus").on("click", (e) => this.handleParticipantChange(e, -1));
        $(".book_time .genric-btn").on("click", (e) => this.handleTimePick(e));
        $('#book_datepicker').on("change", (e) => this.handleDateChange(e));
        $('#chooseTourType').on("change", (e) => this.handleTourTypeChange(e));
    }

    loadCalendar() {
        const selectedDate = this.date ? this.date : "Please select the date...";
        $('#book_datepicker').datepicker({
            value: selectedDate,
            uiLibrary: 'materialdesign',
            iconsLibrary: 'fontawesome',
            footer: false,
            format: 'ddd, dd mmm yyyy',
            disableDates: (date) => {
                const yesterday = new Date();
                yesterday.setDate(yesterday.getDate() - 1);
                return date > yesterday;
            }
        });
    }

    // ------------------- TOUR TYPE CHANGE -------------------
    async handleTourTypeChange() {
        console.log("Tour type changed");
        // reset price
        const tourData = {
            tourId: parseInt($("input[name='tour_id']").val(), 10) || 0,
            tourVariantId: parseInt($("#chooseTourType").val(), 10) || 0,
            quantity: this.adult,
        }
        $('.fullscreen-spinner').removeClass('d-none');
        try {
            const response = await fetch(`${sgttData.root_url}/wp-json/sgtt/v1/tour/price`, {
                method: "POST",
                headers: { 
                    "Content-Type": "application/json",
                    "X-WP-Nonce": sgttData.nonce 
                },
                body: JSON.stringify(tourData)
            });

            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }
            const data = await response.json();
            this.updateBookingFormPrices(data);
            this.repopulateBookingForm();

        } catch (error) {
            console.error("Failed to update cart:", error);
        } finally {
            $('.fullscreen-spinner').addClass('d-none'); // hide loader after everything is done
        }
    }
    updateBookingFormPrices(tourData) {
        if (tourData && tourData.priceAdult && tourData.priceChild) {
            var originalAdultPrice = `${tourData.priceAdult}/pax`;
            var originalChildPrice = `${tourData.priceChild}/pax`;
            if(tourData.priceAdultDiscount) {
                $(`.book_participant .adult-price .discounted-price`).text(tourData.priceAdultDiscount + '/pax').removeClass('d-none');
                originalAdultPrice = `Original Price: ${tourData.priceAdult}/pax`;
            }
            if(tourData.priceChildDiscount) {
                $(`.book_participant .child-price .discounted-price`).text(tourData.priceChildDiscount + '/pax').removeClass('d-none');
                originalChildPrice = `Original Price: ${tourData.priceChild}/pax`;
            }
            $(`.book_participant .adult-price .original-price`).text(originalAdultPrice);
            $(`.book_participant .child-price .original-price`).text(originalChildPrice);
            
        }

    }


    // ------------------- DATE / TIME -------------------

    handleDateChange() {
        this.date = $('#book_datepicker').val();
        if (!this.date) {
            $('#book_datepicker').val("Please select the date...");
        }
        $("input[name='selectedDate']").val(this.date);
        this.updateBookingSummary();
    }

    handleTimePick(e) {
        const parent = $(e.target).closest(".button-group-area");
        parent.find(".primary").removeClass("primary").addClass("primary-border");
        $(e.target).removeClass("primary-border").addClass("primary");

        this.time = $(e.target).text();
        $("input[name='selectedTime']").val(this.time);
        this.updateBookingSummary();
    }

    // ------------------- PARTICIPANTS -------------------
    async handleParticipantChange(e, delta) {
        e.preventDefault();
        const input = $(e.target).closest(".pts-amount").find("input");
        const currentValue = parseInt(input.val(), 10) || 0;
        const newValue = Math.max(0, currentValue + delta);

        input.val(newValue);

        const typeOfPerson = input.prop("name");
        if (typeOfPerson === "adult") {
            this.adult = newValue;
            if(this.productType === 'tour'){
                this.handleTourTypeChange();
            }
        } else if (typeOfPerson === "youth") {
            this.youth = newValue;
        } else if (typeOfPerson === "child") {
            this.child = newValue;
        }
        this.updateBookingSummary();
    }

    // ------------------- SUMMARY -------------------
    updateBookingSummary() {
        if (this.date && this.time && this.adult > 0) {
            $(".book.book_summary").removeClass("d-none"); // show summary box
            this.calculateCartAndUpdateSummary();
        } else {
            $(".book.book_summary").addClass("d-none"); // hide summary box
        }
    }

    // ------------------- CART / SUMMARY -------------------
    async calculateCartAndUpdateSummary() {
        let cartData = this.prepareCartData();
        $('.fullscreen-spinner').removeClass('d-none');
        console.log("Updating cart with data:", cartData);
        try {
            const response = await fetch(`${sgttData.root_url}/wp-json/sgtt/v1/cart/update`, {
                method: "POST",
                headers: { 
                    "Content-Type": "application/json",
                    "X-WP-Nonce": sgttData.nonce 
                },
                body: JSON.stringify(cartData)
            });

            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }
            const data = await response.json();
            this.displaySummaryCart(data);

        } catch (error) {
            console.error("Failed to update cart:", error);
        } finally {
            $('.fullscreen-spinner').addClass('d-none'); // hide loader after everything is done
        }
    }

    prepareCartData() {
        const productId = parseInt($("input[name='product_id']").val(), 10) || 0;
        const tourVariantId = parseInt($("#chooseTourType").val(), 10) || 0;
        const participants = [];
        participants.push({ type: "adult", quantity: this.adult });
        participants.push({ type: "child", quantity: this.youth });
        participants.push({ type: "infant", quantity: this.child });
          
        const cartData = {
            // isCreate: true,
            productId: productId, 
            tourId: productId,
            tourVariantId: tourVariantId,
            bookDate: this.date || "",
            bookTime: this.time || "",
            productType: this.productType,
            // contactLeader: contactLeader,
            // extra_fees: extraFees,
            participants: participants
        };
        return cartData;
    }  

    displaySummaryCart(cartData) {
        const $summary = $(".book_summary");
        // console.log("Cart updated: " + JSON.stringify(cartData));
        if (cartData && cartData.participants) {

            // Date and Time
            $summary.find(".date_time_value").removeClass("d-none").text(`${cartData.formattedBookTime || ""}`);

            // Participants
            const $participants = $summary.find(".participants");
            $participants.empty(); // clear old lines first

            cartData.participants.forEach(participant => {
                let line = `
                    <span>${participant.type.charAt(0).toUpperCase()}${participant.type.slice(1)}: 
                    ${participant.quantity}`;
                if(cartData.cartType !== 'QUOTATION') {
                    line += ` x ${participant.formattedPrice}`;
                }
                line += `</span><br>`;
                $participants.append(line);
            });

            // Total Price
            if(cartData.cartType !== 'QUOTATION') {
                const totalLine = `Total Price: ${cartData.formattedTotalPrice}`;
                $summary.find(".subtotal_price").text(`${cartData.formattedSubtotalPrice}`);
                $summary.find(".discount_price").text(`- ${cartData.formattedTotalDiscount ? cartData.formattedTotalDiscount : '$0.00'}`);
                $summary.find(".total_price").text(totalLine);
            }
        } 
        else {
            $summary.find(".date_time_value").addClass("d-none").html("");
            $summary.find(".participants").empty();
            $summary.find(".total_price").html("");
        }
        this.enableCheckoutButton(cartData);
    }

    enableCheckoutButton(cartData = null) {
        if(cartData && cartData.qualified && cartData.qualified !== 'GOOD') {
            $(".book_summary .validation_error_msg.required").removeClass("d-none").text(cartData.qualified);
            $(".book_checkout_btn .genric-btn").addClass("disable");
            return;
        }
        if(cartData && cartData.error)    {
            $(".book_summary .validation_error_msg.required").removeClass("d-none").text(cartData.message);
            $(".book_checkout_btn .genric-btn").addClass("disable");
            return;
        }
        
        $(".book_summary .validation_error_msg.required").addClass("d-none");
        $(".book_checkout_btn .genric-btn").removeClass("disable");
    }

    repopulateBookingForm() {
        this.date = $("input[name='selectedDate']").val();
        this.time = $("input[name='selectedTime']").val();
        this.adult = parseInt($("input[name='adult']").val());
        this.youth = parseInt($("input[name='youth']").val());
        this.child = parseInt($("input[name='child']").val());
        this.updateBookingSummary();
    }
    resetValues() {
        this.date = null;
        this.time = null;
        this.adult = 0;
        this.youth = 0;
        this.child = 0;
        this.updateBookingSummary();
    }
}

export default CartHandler;
